import { get } from '../utils/api';

export default class UnitTypeService {
  async getUnitTypes() {
    return await get('/unit-types');
  }
}
